import React from "react";
import { Card, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Header from "./header";
import Footer from "./footer";

export default function Frontend() {
  // Sample job openings data
  const jobOpenings = [
    {
      title: "Frontend Developer",
      company: "Techlight",
      location: "india, Remote",
      salary: "₹10L - ₹20L",
      description:
        "Techlight is seeking a passionate Frontend Developer to join our dynamic team. In this role, you will collaborate with cross-functional teams to design and develop innovative web applications. We value creativity, problem-solving, and a strong commitment to quality code.",
    },
    {
      title: "Senior Frontend Engineer",
      company: "InnoTechies",
      location: "india, Remote",
      salary: "₹10L - ₹20L",
      description:
        "Join InnovateTech as a Senior Frontend Engineer and take a lead role in architecting scalable and maintainable web solutions. Work closely with UX/UI designers to create delightful user experiences. If you have a proven track record of delivering high-quality frontend projects, we want to hear from you!",
    },
    {
      title: "Frontend UI/UX Designer",
      company: "DesignsHubspot",
      location: "india, Remote",
      salary: "₹10L - ₹20L",
      description:
        "DesignHub is in search of a talented Frontend UI/UX Designer to shape the visual aspects of our web applications. As a key member of our design team, you'll contribute to the user interface and overall user experience. Bring your creative flair and passion for user-centric design to our collaborative environment.",
    },
    {
      title: "React.js Developer",
      company: "KCodeCrafters",
      location: "india, Remote",
      salary: "₹10L - ₹20L",
      description:
        "CodeCrafters is expanding its team and looking for a skilled React.js Developer. If you have expertise in building responsive and scalable web applications using React.js, this is the perfect opportunity for you. Join us in pushing the boundaries of web development and delivering cutting-edge solutions.",
    },
    {
      title: "Frontend Software Engineer",
      company: "ByteCraft",
      location: "india, Remote",
      salary: "₹10L - ₹20L",
      description:
        "ByteCraft is looking for a Frontend Software Engineer to contribute to the development of our next-generation web applications. You'll work on implementing user interfaces, optimizing performance, and collaborating with backend developers to deliver seamless user experiences.",
    },
    {
      title: "UI Developer",
      company: "PixelPerfection",
      location: "india, Remote",
      salary: "₹10L - ₹20L",
      description:
        "PixelPerfection is hiring a UI Developer with a keen eye for detail. Join our creative team and play a key role in crafting visually stunning and user-friendly interfaces. If you have a passion for design and a strong foundation in frontend technologies, we want to hear from you.",
    },
    {
      title: "Frontend Architect",
      company: "CodeVisionary",
      location: "india, Remote",
      salary: "₹10L - ₹20L",
      description:
        "CodeVisionary is seeking a Frontend Architect to lead the design and implementation of scalable and maintainable frontend architectures. If you have a deep understanding of frontend technologies and a track record of successful architectural decisions, apply now and shape the future of our products.",
    },
    {
      title: "Angular Developer",
      company: "AngularMasters",
      location: "india, Remote",
      salary: "₹10L - ₹20L",
      description:
        "AngularMasters is on the lookout for a skilled Angular Developer to join our team. If you have expertise in Angular and a passion for building robust and scalable web applications, this is an exciting opportunity to contribute to cutting-edge projects and enhance your skills.",
    },
    {
      title: "Frontend Tech Lead",
      company: "TechLeadership",
      location: "india, Remote",
      salary: "₹10L - ₹20L",
      description:
        "TechLeadership is hiring a Frontend Tech Lead to guide and mentor our frontend development team. In this role, you'll be responsible for technical leadership, code reviews, and ensuring the successful delivery of high-quality frontend solutions. Join us in driving technical excellence.",
    },
    {
      title: "Vue.js Developer",
      company: "VueMasters",
      location: "india, Remote",
      salary: "₹10L - ₹20L",
      description:
        "VueMasters is looking for a talented Vue.js Developer to contribute to the development of our web applications. If you have a strong command of Vue.js and a passion for creating intuitive and responsive user interfaces, we want you on our team!",
    },
    {
      title: "Frontend Accessibility Specialist",
      company: "AccessWeb",
      location: "india, Remote",
      salary: "₹10L - ₹20L",
      description:
        "AccessWeb is dedicated to creating inclusive and accessible web experiences. We're hiring a Frontend Accessibility Specialist to ensure our applications are accessible to users of all abilities. If you're passionate about web accessibility, join us in making the web a more inclusive space.",
    },
    {
      title: "Frontend Performance Engineer",
      company: "SpeedOptimize",
      location: "india, Remote",
      salary: "₹10L - ₹20L",
      description:
        "SpeedOptimize is seeking a Frontend Performance Engineer to optimize the speed and efficiency of our web applications. If you have a strong background in performance optimization techniques and a drive for creating lightning-fast user experiences, apply now and be a part of our high-performance team.",
    },
    {
      title: "Web Design Specialist",
      company: "DesignCrafters",
      location: "india, Remote",
      salary: "₹10L - ₹20L",
      description:
        "DesignCrafters is looking for a Web Design Specialist with expertise in frontend technologies and a focus on creating visually appealing and user-friendly web interfaces. If you have a passion for design and a strong technical skill set, join us in shaping the visual identity of our products.",
    },
    {
      title: "Frontend Testing Engineer",
      company: "TestMasters",
      location: "india, Remote",
      salary: "₹10L - ₹20L",
      description:
        "TestMasters is hiring a Frontend Testing Engineer to ensure the quality and reliability of our web applications. If you have experience in frontend testing frameworks and a keen eye for identifying and fixing bugs, join us in delivering flawless user experiences.",
    },
    {
      title: "Full Stack Developer (Frontend Focus)",
      company: "FullStackGenius",
      location: "india, Remote",
      salary: "₹10L - ₹20L",
      description:
        "FullStackGenius is looking for a Full Stack Developer with a strong focus on frontend technologies. Join our versatile team and contribute to both frontend and backend development, creating end-to-end solutions for our clients. If you thrive in a dynamic environment, apply now!",
    },
    {
      title: "Frontend Mobile App Developer",
      company: "MobileInnovate",
      location: "india, Remote",
      salary: "₹10L - ₹20L",
      description:
        "MobileInnovate is expanding its team and seeking a Frontend Mobile App Developer to create engaging and responsive mobile interfaces. If you have experience in mobile app development and a passion for crafting seamless user experiences, join us in shaping the future of mobile applications.",
    },
    {
      title: "Frontend E-commerce Developer",
      company: "EcommerceTech",
      location: "india, Remote",
      salary: "₹10L - ₹20L",
      description:
        "EcommerceTech is looking for a Frontend E-commerce Developer to enhance the user experience of our online shopping platforms. If you have expertise in frontend technologies and a deep understanding of e-commerce best practices, join us in revolutionizing online shopping.",
    },
    {
      title: "Web Animation Specialist",
      company: "AnimateWeb",
      location: "india, Remote",
      salary: "₹10L - ₹20L",
      description:
        "AnimateWeb is hiring a Web Animation Specialist to bring our web interfaces to life. If you have a passion for creating visually stunning animations and a strong foundation in frontend development, apply now and be a part of our creative and dynamic team.",
    },
    {
      title: "Frontend DevOps Engineer",
      company: "DevOpsFront",
      location: "india, Remote",
      salary: "₹10L - ₹20L",
      description:
        "DevOpsFront is seeking a Frontend DevOps Engineer to optimize the deployment and maintenance of our frontend applications. If you have experience in DevOps practices and a focus on frontend infrastructure, join us in ensuring the reliability and scalability of our web solutions.",
    },
    {
      title: "Frontend Data Visualization Specialist",
      company: "DataVizGenius",
      location: "DataHub, Remote",
      salary: "₹10L - ₹20L",
      description:
        "DataVizGenius is looking for a Frontend Data Visualization Specialist to create compelling and informative data visualizations for our web applications. If you have a strong background in data visualization libraries and a passion for transforming data into insights, apply now!",
    },
    // Add more job openings as needed
  ];

  return (
    <>
      <Helmet>
        <title>Front End Web Developer Jobs 2025</title>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta
          name="description"
          content="Find remote frontend developer job opportunities with leading companies in 2025."
        />
        <meta
          name="keywords"
          content="frontend developer, remote jobs, web development, React, JavaScript"
        />
        <meta name="author" content="Your Name" />
        {/* Add more meta tags as needed */}
      </Helmet>
      <Header />
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-12 mb-12 text-center">
            <h1 className="font-weight-bold">Frontend Developer Jobs 2025</h1>
            <p className="lead">
              Explore exciting remote opportunities in frontend development with
              leading companies.
            </p>
          </div>
          {jobOpenings.map((job, index) => (
            <div key={index} className="col-md-12 mb-12">
              <Card>
                <Card.Body>
                  <Card.Title>{job.title}</Card.Title>
                  <Card.Text>{job.salary}</Card.Text>
                  <Card.Subtitle className="mb-12 text-muted">
                    {job.company} - {job.location}
                  </Card.Subtitle>
                  <Card.Text>{job.description}</Card.Text>
                  <div className="d-flex justify-content-between align-items-center">
                    <Button variant="primary">Apply Now</Button>
                    <span>Today</span>
                  </div>
                </Card.Body>
              </Card>{" "}
              <br />
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
